module.exports = __webpack_public_path__ + "static/69c7fae965a64d0eebed4de66675e8faf6e93e32f2320430cc1925478772ee4e-814a87c02b5c13791066dda5e0512961.png";